import { useQuery } from '@tanstack/react-query';
import {
  IDeclaracaoTitularArrendatarioNaoIniciada,
  IDeclaracaoTitularOuArrendatarioExistente,
} from '../../../../interfaces/IDeclaracoes';
import CustomTabTitularArrendatario from '../../components/customTab/customTabTitularArrendatario';
import { useBackEndRequests } from './../../lib/backEndRequests';
import ErrorMessage from '../../../../components/errorMessage/errorMessage';
import { useNavigate } from 'react-router-dom';
import { IErrorWithSentryId } from 'interfaces/IErrorWithSentryId';

function TitularArrendatarioTab({ year }: { year: string }) {
  const cnpj = sessionStorage.getItem('userCpfCnpj');

  const { getDeclaracoesNaoIniciadas, getDeclaracoes } = useBackEndRequests();

  const {
    data: declaracoesNaoIniciadasData,
    isLoading: isDeclaracoesNaoIniciadasLoading,
    isError: isDeclaracoesError,
    error: DeclaracoesError,
  } = useQuery<IDeclaracaoTitularArrendatarioNaoIniciada[], IErrorWithSentryId>({
    queryKey: ['declaracaoTitularArrendatarioNaoIniciadasQuery', [year, cnpj]],
    queryFn: () => getDeclaracoesNaoIniciadas(cnpj || '', year, 1),
    refetchOnWindowFocus: false,
    retryDelay: 100,
  });

  const {
    data: declaracoesExistentesData,
    isLoading: isDeclaracoesExistentesLoading,
    isError: isDeclaracoesExistentesError,
    error: DeclaracoesExistentesError,
  } = useQuery<IDeclaracaoTitularOuArrendatarioExistente[], IErrorWithSentryId>({
    queryKey: ['declaracaoTitularArrendatarioExistentesQuery', [year, cnpj]],
    queryFn: () => getDeclaracoes(cnpj || '', year, 1) as Promise<IDeclaracaoTitularOuArrendatarioExistente[]>,
    retryDelay: 100,
  });

  const navigate = useNavigate();

  return (
    <>
      {isDeclaracoesError || isDeclaracoesExistentesError ? (
        <ErrorMessage
          errorMessage={
            DeclaracoesError?.message || DeclaracoesExistentesError?.message || 'Erro ao carregar as declarações'
          }
          error={DeclaracoesError || DeclaracoesExistentesError}
          onClickFunction={() => navigate(0)}
        />
      ) : (
        <CustomTabTitularArrendatario
          declaracoesNaoIniciadasData={declaracoesNaoIniciadasData || []}
          declaracoesData={declaracoesExistentesData || []}
          isDeclaracoesNaoIniciadasLoading={isDeclaracoesNaoIniciadasLoading}
          isDeclaracoesExistentesLoading={isDeclaracoesExistentesLoading}
          declaracaoType='titular-ou-arrendatario'
        />
      )}
    </>
  );
}

export default TitularArrendatarioTab;
